<template>
  <div class="content resize">
    <e-breadcrumbs />
    <win-layer-pop class="rmk_pop">
      <component
        v-if="rmkComponent"
        :is="rmkComponent"
        @close="closeRmkPopup"
        :parent-info="parentInfo"
      />
    </win-layer-pop>
    <win-layer-pop class="promotion_pop">
      <component
        v-if="promotionComponent"
        :is="promotionComponent"
        @close="closePromotionPopup"
        :parent-info="parentInfo"
      />
    </win-layer-pop>
    <win-layer-pop class="gift_pop">
      <component
        v-if="gifticonComponent"
        :is="gifticonComponent"
        @close="closeGiftPopup"
        :parent-info="parentInfo"
      />
    </win-layer-pop>
    <h1 class="page_title">
      {{ $t('msg.COUP100.001') }} <a class="button" href="#" @click.prevent="pdfDownload('쿠폰 사용 FAQ_241118.pdf')"> {{ $t('msg.COUP100.028') }}</a>
    </h1><!-- 나의 할인쿠폰 -->
    <form id="frm2">
      <div style="width: 1250px;" class="content_box beforetab">
        <table class="tbl_search">
          <colgroup>
            <col :width="[serviceCtrCd === 'KR' ? '60px' : '80px']">
            <col width="150px">
            <col width="324px">
            <col width="50px">
            <col width="170px">
            <col width="160px">
            <col width="50px">
            <col width="120px">
          </colgroup>
          <tbody>
            <tr>
              <th>{{ $t('msg.COUP100.020') }}</th><!-- 쿠폰 타입 -->
              <td>
                <select v-model="params.couponTyp" class="wid150">
                  <option value="">{{ $t('msg.COUP100.021') }}</option>
                  <option value="01">{{ $t('msg.COUP100.022') }}</option>
                  <option value="02">{{ $t('msg.COUP100.023') }}</option>
                  <option value="03">{{ $t('msg.COUP100.024') }}</option>
                  <option value="04">{{ $t('msg.COUP100.092') }}</option>
                  <option value="05">{{ $t('msg.COUP100.093') }}</option>
                </select>
              </td>
            </tr>
            <tr>
              <th>{{ $t('msg.FARE020T010.001') }}</th><!-- 출발 -->
              <td colspan="2">
                <e-auto-complete-place
                  id="polPol"
                  @change="changePol"
                  :ctr-cd="params.porCtrCd"
                  :plc-cd="params.porPlcCd"
                  :is-char="true"
                  :is-char-alert="true"
                />
              </td>
              <th>{{ $t('msg.FARE020T010.002') }}</th><!-- 도착 -->
              <td colspan="4">
                <e-auto-complete-place
                  id="podPod"
                  @change="changePod"
                  :ctr-cd="params.dlyCtrCd"
                  :plc-cd="params.dlyPlcCd"
                  :is-char="true"
                  :is-char-alert="true"
                />
              </td>
              <td class="text_right">
              </td>
            </tr>
            <tr>
              <th>{{ $t('msg.FARE020T010.003') }}</th><!-- 기간 -->
              <td>
                <select v-model="params.kind" class="wid150">
                  <option value="R">ETD</option><!-- ETD 기준 -->
                </select>
              </td>
              <td colspan="3">
                <e-date-range-picker
                  id="date_picker"
                  :sdate="params.fromDt"
                  :edate="params.toDt"
                  :is-debug="true"
                  @change="changeDateRange"
                />
              </td>
              <th style="text-align: right; padding-right: 15px;">{{ $t('msg.COUP100.014') }}</th><!-- TYPE -->
              <td colspan="2">
                <select v-model="params.cntrTyp" class="wid150">
                  <option value="">{{ $t('msg.COUP100.021') }}</option>
                  <option value="GP">{{ $t('msg.COUP100.025') }}</option>
                  <option value="TK">{{ $t('msg.COUP100.026') }}</option>
                  <option value="RF">{{ $t('msg.COUP100.027') }}</option>
                </select>
              </td>
              <td class="text_right">
                <a class="button blue sh" href="#" @click.prevent="searchMyCoupon(true)">{{ $t('msg.FARE020T010.013') }}</a><!-- 검색 -->
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <span style="font-size: 18px; font-weight: bolder; color: red;">{{ $t('msg.COUP100.029') }}</span>
      <div style="width: 1250px;" class="content_box">
        <div id="realgrid" class="mt5" style="width: 100%; height: 650px;" />
      </div>
    </form>
  </div>
</template>

<script>

import EAutoCompletePlace from '@/components/common/EAutoCompleteCtrPlace'
import schedule from '@/api/rest/schedule/schedule'

import { rootComputed } from '@/store/helpers'

import { createGrid } from '@/plugins/realgridUtil'
import JSZip from 'jszip'
import moment from 'moment'
import EBreadcrumbs from '@/components/common/EBreadcrumbs.vue'
import intergis from '@/api/rest/common/intergis'

let gridView = null
let provider = null

const fields = [
  { fieldName: 'couponNo', dataType: 'text' }, // 쿠폰번호
  { fieldName: 'couponTyp', dataType: 'text' }, // 쿠폰타입
  { fieldName: 'couponCon', dataType: 'text' }, // 쿠폰조건
  { fieldName: 'targetNo', dataType: 'text' }, //타겟번호
  { fieldName: 'targetStatus', dataType: 'text' }, //타겟상태
  { fieldName: 'porCtrCd', dataType: 'text' }, // 출항지 국가 코드
  { fieldName: 'porCtrNm', dataType: 'text' }, // 출항지 국가 명
  { fieldName: 'porPlcCd', dataType: 'text' }, // 출항지 지역
  { fieldName: 'dlyCtrCd', dataType: 'text' }, // 도착지 국가 코드
  { fieldName: 'dlyCtrNm', dataType: 'text' }, // 도착지 국가 명
  { fieldName: 'dlyPlcCd', dataType: 'text' }, // 도착지 지역
  { fieldName: 'strDt', dataType: 'datetime', datetimeFormat: 'yyyyMMdd' }, // 시작일
  { fieldName: 'endDt', dataType: 'datetime', datetimeFormat: 'yyyyMMdd' }, // 만료일
  { fieldName: 'cntrTypCd', dataType: 'text' }, // CNTR TYPE
  { fieldName: 'of20Rate', dataType: 'text' }, // 20 DC 금액
  { fieldName: 'of40Rate', dataType: 'text' }, // 40 DC 금액
  { fieldName: 'rmk', dataType: 'text' }, //비고
  { fieldName: 'couponNm', dataType: 'text' }, //쿠폰명
  { fieldName: 'bookingBtn', dataType: 'text' }
]

const columns = [
  { name: 'couponNo', fieldName: 'couponNo', header: { text: app.$t('msg.COUP100.005') }, editable: false, width: 15 },
  // { name: 'couponTyp', fieldName: 'couponTyp', header: { text: app.$t('msg.COUP100.020') }, editable: false, width: 15 },
  {
    name: 'couponTyp',
    fieldName: 'couponTyp',
    header: { text: app.$t('msg.COUP100.020') },
    editable: false,
    width: 15,
    lookupDisplay: true,
    values: ['01', '02', '03', '04', '05'],
    labels: [
      app.$t('msg.COUP100.022'),
      app.$t('msg.COUP100.023'),
      app.$t('msg.COUP100.024'),
      app.$t('msg.COUP100.092'),
      app.$t('msg.COUP100.093')
    ]
  },
  {
    name: 'couponCon',
    fieldName: 'couponCon',
    header: { text: app.$t('msg.COUP100.094') },
    editable: false,
    width: 15,
    renderer: {
      type: 'html',
      callback (grid, cell) {
        const idx = cell.index.dataRow
        let couponCon = grid.getValue(idx, 'couponCon')
        const couponTyp = grid.getValue(idx, 'couponTyp')

        if (!couponCon) couponCon = ''

        if (couponTyp === '04') {
          return couponCon ? `출발일 ${couponCon}일전 부킹<br/>(선복보장)` : ''
        } else if (couponTyp === '05') {
          if (!couponCon) return ''

          const [cargo20, cargo40] = couponCon.split('/')

          return `
            20' Cargo ${cargo20 || ''}kg<br/>
            40' Cargo ${cargo40 || ''}kg
          `
        }

        return ''
      }
    }
  },
  { name: 'targetNo', fieldName: 'targetNo', header: { text: app.$t('msg.COUP100.005') }, editable: false, width: 15 },
  { name: 'targetStatus', fieldName: 'targetStatus', header: { text: app.$t('msg.COUP100.005') }, editable: false, width: 15 },
  { name: 'porCtrCd', fieldName: 'porCtrCd', header: { text: app.$t('msg.COUP100.005') }, editable: false, width: 15 },
  { name: 'porCtrNm', fieldName: 'porCtrNm', header: { text: app.$t('msg.COUP100.003') }, editable: false, width: 15 },
  { name: 'porPlcCd', fieldName: 'porPlcCd', header: { text: app.$t('msg.COUP100.003') }, editable: false, width: 10 },
  { name: 'dlyCtrCd', fieldName: 'dlyCtrCd', header: { text: app.$t('msg.COUP100.005') }, editable: false, width: 15 },
  { name: 'dlyCtrNm', fieldName: 'dlyCtrNm', header: { text: app.$t('msg.COUP100.004') }, editable: false, width: 15 },
  { name: 'dlyPlcCd', fieldName: 'dlyPlcCd', header: { text: app.$t('msg.COUP100.004') }, editable: false, width: 10 },
  { name: 'strDt', fieldName: 'strDt', header: { text: app.$t('msg.COUP100.007') }, editable: false, width: 15 },
  { name: 'endDt', fieldName: 'endDt', header: { text: app.$t('msg.COUP100.008') }, editable: false, width: 15 },
  { name: 'cntrTypCd', fieldName: 'cntrTypCd', header: { text: app.$t('msg.COUP100.009') }, editable: false, width: 10 },
  { name: 'of20Rate', fieldName: 'of20Rate', header: { text: app.$t('msg.COUP100.011') }, editable: false, width: 12 },
  { name: 'of40Rate', fieldName: 'of40Rate', header: { text: app.$t('msg.COUP100.012') }, editable: false, width: 12 },
  {
    name: 'couponNm',
    fieldName: 'couponNm',
    header: { text: app.$t('msg.COUP100.005') },
    editable: false,
    width: 15,
    renderer: {
      showTooltip: true,
      type: 'html',
      callback (grid, cell, w, h) {
        const idx = cell.index.dataRow
        const couponNm = grid.getValue(idx, 'couponNm')
        const couponTyp = grid.getValue(idx, 'couponTyp')

        if (couponTyp === '02') {
          return `<a class="link" href="#" onclick="vmAppEx.openPromotionPopup('KmtcCouponPromotionPop', ${idx})">${couponNm}</a>`
        } else {
          return `<a>${couponNm}</a>`
        }
      }
    }
  },
  {
    name: 'rmk',
    fieldName: 'rmk',
    header: { text: app.$t('msg.COUP100.013') },
    editable: false,
    width: 46,
    renderer: {
      showTooltip: true,
      type: 'html',
      callback (grid, cell, w, h) {
        const idx = cell.index.dataRow
        const rmk = grid.getValue(idx, 'rmk')

        return `<a href="#" onclick="vmAppEx.openRmkPopup('KmtcCouponRmkPop', ${idx})">${rmk}</a>`
      }
    }
  },
  {
    name: 'bookingBtn',
    fieldName: 'bookingBtn',
    type: 'text',
    width: '12',
    header: { text: app.$t('msg.COUP100.021') },
    renderer: {
      type: 'html',
      callback: function (grid, cell, w, h) {
        const idx = cell.index.dataRow
        const porCtrCd = grid.getValue(idx, 'porCtrCd')
        let porPlcCd = grid.getValue(idx, 'porPlcCd')
        if (porPlcCd === 'PNC') {
          porPlcCd = 'PUS'
        }
        const dlyCtrCd = grid.getValue(idx, 'dlyCtrCd')
        let dlyPlcCd = grid.getValue(idx, 'dlyPlcCd')
        if (dlyPlcCd === 'PNC') {
          dlyPlcCd = 'PUS'
        }
        const startDt = grid.getValue(idx, 'strDt')
        const couponTyp = grid.getValue(idx, 'couponTyp')
        const targetStatus = grid.getValue(idx, 'targetStatus')

        if (couponTyp === '03' && targetStatus === '01') {
          return `<span class="yes"><a class="button sm" onclick="vmAppEx.openGiftPopup('KmtcCouponGiftPop', ${idx})">${app.$t('msg.COUP100.034')}</a></span>`
        } else if (couponTyp === '03' && targetStatus === '02') {
          if (localStorage.getItem('service_ctrcd') === 'KR') {
            return `<span class="yes"><a class="button sm" onclick="vmAppEx.openGiftPopup('KmtcCouponGiftPop', ${idx})">${app.$t('msg.COUP100.035')}</a></span>`
          } else {
            return `<span class="yes"><a style="height: 45px; white-space: pre-line;" class="button sm" onclick="vmAppEx.openGiftPopup('KmtcCouponGiftPop', ${idx})">${app.$t('msg.COUP100.035')}</a></span>`
          }
        } else if (couponTyp === '03' && targetStatus === '03') {
          if (localStorage.getItem('service_ctrcd') === 'KR') {
            return `<span class="yes"><a class="button sm gray">${app.$t('msg.COUP100.036')}</a></span>`
          } else {
            return `<span class="yes"><a style="height: 45px; white-space: pre-line;" class="button sm gray">${app.$t('msg.COUP100.036')}</a></span>`
          }
        } else if (couponTyp === '03' && targetStatus === '04') {
          if (localStorage.getItem('service_ctrcd') === 'KR') {
            return `<span class="yes"><a class="button sm gray">${app.$t('msg.COUP100.037')}</a></span>`
          } else {
            return `<span class="yes"><a style="height: 45px; white-space: pre-line;" class="button sm gray">${app.$t('msg.COUP100.037')}</a></span>`
          }
        } else {
          return `<span class="yes"><a class="button sm" onclick="vmAppEx.goSchedule('${porCtrCd}', '${porPlcCd}', '${dlyCtrCd}', '${dlyPlcCd}', '${startDt}');">${app.$t('msg.COUP100.033')}</a></span>`
        }
      }
    }
  }
]

const layout = [
    'couponNm',
    'couponTyp',
    'couponCon',
    {
      name: app.$t('msg.COUP100.010'),
      items: [
        { column: 'of20Rate' },
        { column: 'of40Rate' }
      ]
    },
    'strDt',
    'endDt',
    'porCtrNm',
    'dlyCtrNm',
    'rmk',
    'bookingBtn'
  ]

export default {
  name: 'KmtcCoupon',
  components: {
    EBreadcrumbs,
    EAutoCompletePlace,
    'e-date-range-picker': () => import('@/components/common/EDateRangePickerMulti'),
    'win-layer-pop': () => import('@/pages/trans/popup/WinLayerPop'),
    KmtcCouponRmkPop: () => import('@/pages/schedule/popup/KmtcCouponRmkPop'),
    KmtcCouponPromotionPop: () => import('@/pages/schedule/popup/KmtcCouponPromotionPop'),
    KmtcCouponGiftPop: () => import('@/pages/schedule/popup/KmtcCouponGiftPop')
  },
  data () {
    return {
      gridHeight: 510,
      rmkComponent: null,
      promotionComponent: null,
      gifticonComponent: null,
      parentInfo: {
        couponNo: '',
        targetNo: '',
        rmk: ''
      },
      params: {
        porCtrCd: '',
        porPlcCd: '',
        dlyCtrCd: '',
        dlyPlcCd: '',
        kind: 'R',
        fromDt: '',
        toDt: '',
        cntrTyp: '',
        couponTyp: ''
      },
      isSearch: false,
      format: 'YYYY.MM.DD',
      myOceanFreightList: [],
      // 운임 팝업을 띄우기 위해 필요한 데이터
      surChargeParams: {},
      dtChk: true,
      serviceCtrCd: '',
      relYn: true, // JamSin
      raNo: '',
      scNo: '',
      porCtrNm: '',
      porPlcNm: '',
      dlyCtrNm: '',
      dlyPlcNm: '',
      freExpDate: '',
      actShpNm: '',
      req20Ft: '', // 20FT 요청 금액
      req40Ft: '', // 40FT 요청 금액
      apv20FtList: [], // 20FT 승인 금액 리스트
      apv40FtList: [], // 40FT 승인 금액 리스트
      apv20Ft: '',
      apv40Ft: '',
      dlyCtrCd: '', // 도착지 국가 코드
      dlyCtrLssYn: '', // 도착지 국가 LSS 대상 여부
      lssYn: 'Y', // LSS 포함 여부
      negoAfterText: ''
    }
  },
  computed: {
    ...rootComputed
  },
  created () {
    // 비로그인 kmtc on 진입 금지
    if (!this.auth.userId) {
      this.$router.push('/main')
    } else { // 로그인 후 미설정 화주 kmtc on 진입금지
      // 가로배너 클릭, kmtc on 아이콘 클릭 구분하기 위해 로그 전달
      schedule.getKmtcSpotTarget('01').then((response) => {
        if (response.data[0].kmtcSpotCoupon !== 'Y') {
          // this.$router.push('/main')
        }
      })
    }
  },
  destroyed () {
    window.removeEventListener('keydown', this.handleKeydown)
  },
  mounted () {
    window.vmAppEx = this

    //엑셀 다운로드용 JSZip 셋팅
    window.JSZip = window.JSZip || JSZip

    //리얼그리드 셋팅
    const grid = createGrid('realgrid', {
      fields,
      columns,
      layout,
      header: {
        height: 50
      },
      displayOptions: {
        fitStyle: 'even',
        rowHeight: 60,
        columnMovable: false
      },
      editOptions: {
        editable: false,
        updatable: false
      },
      rowIndicator: {
        visible: false
      },
      stateBar: {
        visible: false
      },
      checkBar: {
        visible: false
      },
      footer: {
        visible: false
      }
    })
    gridView = grid.gridView
    provider = grid.provider

    this.$nextTick(function () {
      window.addEventListener('keydown', this.handleKeydown)
    })

    gridView.onShowTooltip = function (grid, idx, value) {
        const columns = ['rmk']
        if (columns.includes(idx.column)) {
          let breakLine = ''
          let oneLine = ''
          let oneLineByteLength = 0

          for (const token of value) {
            oneLine += token

            // 한글과 한글 외 텍스트의 너비 계산
            const unicode = token.charCodeAt(0)
            if (unicode > 127 || (unicode > 64 && unicode < 91)) {
              oneLineByteLength += 2
            } else {
              oneLineByteLength += 1
            }

            // 조건에 따른 개행
            if (token === '\n' || (token === ' ' && oneLineByteLength > 70)) {
              breakLine += oneLine + (token === '\n' ? '' : ' \n')
              oneLine = ''
              oneLineByteLength = 0
            }
          }
          breakLine += oneLine
          return breakLine
        }
      }

    // JamSin 날짜 초기값 셋팅 -1w ~ +1w
    const arrMonthInfo1 = this.$ekmtcCommon.getDefaultStEnDt({ startCode: 'M', startGap: 0, endCode: 'M', endGap: 1 })
    this.params.fromDt = arrMonthInfo1.stDt
    this.params.toDt = arrMonthInfo1.enDt

    this.searchMyCoupon(true) // 검색 실행
  },
  methods: {
    handleKeydown (e) {
      // JamSin
      if (this.relYn) {
        if (e.key === 'Enter') {
          this.searchMyCoupon(true)
        }
      }
    },
    changePol (vo) {
      this.params.porCtrCd = vo.ctrCd
      this.params.porPlcCd = vo.plcCd
      const frm = document.querySelector('#frm2')
      const elem = frm.querySelector('#polPol')
      this.$ekmtcCommon.hideErrorTooltip(elem)
    },
    changePod (vo) {
      this.params.dlyCtrCd = vo.ctrCd
      this.params.dlyPlcCd = vo.plcCd
      const frm = document.querySelector('#frm2')
      const elem = frm.querySelector('#podPod')
      this.$ekmtcCommon.hideErrorTooltip(elem)
    },
    async searchMyCoupon (searchBtnClick) {
      // 조회
      if (this.fnValidationAll()) {
        // '검색'버튼을 누른 경우
        if (searchBtnClick !== undefined && searchBtnClick) {
          this.isSearch = true
        }

        const formData = JSON.parse(JSON.stringify(this.params))

        if (this.$ekmtcCommon.isNotEmpty(formData.fromDt)) {
          formData.fromDt = formData.fromDt.replaceAll('.', '')
        }
        if (this.$ekmtcCommon.isNotEmpty(formData.toDt)) {
          formData.toDt = formData.toDt.replaceAll('.', '')
        }

        await schedule.getMyCouponList(this.params).then(response => {
          this.list = response.data

          provider.setRows(this.list)
          gridView.setCurrent({ itemIndex: 0 })

          if (this.list.length === 0) {
            provider.setRows(this.list)
            gridView.setCurrent({ itemIndex: 0 })
            this.$ekmtcCommon.alertCallback(this.$t('msg.ONEX010T010.073'), () => {
              return false
            })
          }
        }).catch(err => {
          console.log(err)
        })
      }
    },
    openRmkPopup (compNm, idx) {
      // inline handler 에 자유 텍스트를 문자열로 보간하면 따옴표·개행에서 SyntaxError 가 나므로 행 인덱스로 조회한다.
      const rmk = this.list[idx].rmk
      if (this.rmkComponent !== null) {
        this.rmkComponent = null
        this.$ekmtcCommon.layerClose('.rmk_pop')
      }
      this.rmkComponent = compNm
      this.parentInfo.rmk = rmk

      this.$ekmtcCommon.layerOpen('.rmk_pop')
    },
    closeRmkPopup () {
      this.rmkComponent = null
      this.$ekmtcCommon.layerClose('.rmk_pop')
    },
    openPromotionPopup (compNm, idx) {
      const { couponNo, couponNm } = this.list[idx]
      if (this.promotionComponent !== null) {
        this.promotionComponent = null
        this.$ekmtcCommon.layerClose('.promotion_pop')
      }
      this.promotionComponent = compNm
      this.parentInfo.couponNo = couponNo
      this.parentInfo.couponNm = couponNm

      this.$ekmtcCommon.layerOpen('.promotion_pop')
    },
    closePromotionPopup () {
      this.promotionComponent = null
      this.$ekmtcCommon.layerClose('.promotion_pop')
    },
    openGiftPopup (compNm, idx) {
      const { couponNo, couponNm, targetNo } = this.list[idx]
      if (this.gifticonComponent !== null) {
        this.gifticonComponent = null
        this.$ekmtcCommon.layerClose('.gift_pop')
      }
      this.gifticonComponent = compNm
      this.parentInfo.couponNo = couponNo
      this.parentInfo.couponNm = couponNm
      this.parentInfo.targetNo = targetNo

      this.$ekmtcCommon.layerOpen('.gift_pop')
    },
    closeGiftPopup () {
      this.gifticonComponent = null
      this.$ekmtcCommon.layerClose('.gift_pop')
      this.searchMyCoupon(true)
    },
    // '검색'버튼 클릭시 검색조건 전체 validation check
    fnValidationAll () {
      const frm = document.querySelector('#frm2')
      let isAllOk = true

      // 출발지 validation check
      if (!this.fnValidationPor(frm)) {
        isAllOk = false
      }
      // 도착지 validation check
      if (!this.fnValidationDly(frm)) {
        isAllOk = false
      }

      return isAllOk && this.dtChk
    },
    // 출발지 validation check
    fnValidationPor (frm) {
      if (frm === undefined) {
        frm = document.querySelector('#frm2')
      }

      const elem = frm.querySelector('#polPol')
      const inputElem = elem.querySelector('input')
      const inputValue = inputElem.value
      let isOk = true
      let msg = ''

      if (this.$ekmtcCommon.isNotEmpty(inputValue) && (this.$ekmtcCommon.isEmpty(this.params.porCtrCd) || this.$ekmtcCommon.isEmpty(this.params.porPlcCd))) {
        msg = this.$t('msg.FARE010T010.013') // 출발지를 입력해 주세요.
        isOk = false
      }

      if (!isOk) {
        this.$ekmtcCommon.showErrorTooltip(elem, msg)
      } else {
        this.$ekmtcCommon.hideErrorTooltip(elem)
      }

      return isOk
    },
    // 도착지 validation check
    fnValidationDly (frm) {
      if (frm === undefined) {
        frm = document.querySelector('#frm2')
      }

      const elem = frm.querySelector('#podPod')
      const inputElem = elem.querySelector('input')
      const inputValue = inputElem.value
      let isOk = true
      let msg = ''

      if (this.$ekmtcCommon.isNotEmpty(inputValue) && (this.$ekmtcCommon.isEmpty(this.params.dlyCtrCd) || this.$ekmtcCommon.isEmpty(this.params.dlyPlcCd))) {
        msg = this.$t('msg.FARE010T010.014') // 도착지를 입력해 주세요.
        isOk = false
      }

      if (!isOk) {
        this.$ekmtcCommon.showErrorTooltip(elem, msg)
      } else {
        this.$ekmtcCommon.hideErrorTooltip(elem)
      }

      return isOk
    },
    // 시작일 validation check
    fnValidationFromDt (frm) {
      if (frm === undefined) {
        frm = document.querySelector('#frm2')
      }

      const elem = frm.querySelector('#date_picker')
      let isOk = true
      let msg = ''

      if (this.$ekmtcCommon.isEmpty(this.params.fromDt)) {
        msg = '시작일을 선택해 주세요.' // 시작일을 선택해 주세요.
        isOk = false
      }

      if (!isOk) {
        this.$ekmtcCommon.showErrorTooltip(elem, msg)
      } else {
        this.$ekmtcCommon.hideErrorTooltip(elem)
      }

      return isOk
    },
    // 종료일 validation check
    fnValidationToDt (frm) {
      if (frm === undefined) {
        frm = document.querySelector('#frm2')
      }

      const elem = frm.querySelector('#date_picker')
      let isOk = true
      let msg = ''

      if (this.$ekmtcCommon.isEmpty(this.params.toDt)) {
        msg = '종료일을 선택해 주세요.' // 종료일을 선택해 주세요.
        isOk = false
      }

      if (!isOk) {
        this.$ekmtcCommon.showErrorTooltip(elem, msg)
      } else {
        this.$ekmtcCommon.hideErrorTooltip(elem)
      }

      return isOk
    },
    changeDateRange (sdt, edt) {
      const frm = document.querySelector('#frm2')
      const selector = frm.querySelector('#date_picker')

      this.params.fromDt = sdt
      this.params.toDt = edt

      this.$ekmtcCommon.hideErrorTooltip(selector)
      this.dtChk = true
    },
    async goSchedule (porCtrCd, porPlcCd, dlyCtrCd, dlyPlcCd, startDt) {
      var js_date = new Date(startDt)
      var year = js_date.getFullYear()
      var month = js_date.getMonth() + 1
      if (month < 10) {
        month = '0' + month
      }

      if (porCtrCd === 'undefined') {
        porCtrCd = ''
      }
      if (porPlcCd === 'undefined') {
        porPlcCd = ''
      }
      if (dlyCtrCd === 'undefined') {
        dlyCtrCd = ''
      }
      if (dlyPlcCd === 'undefined') {
        dlyPlcCd = ''
      }

      const params = {
        porCtrCd: porCtrCd,
        porPlcCd: porPlcCd,
        dlyCtrCd: dlyCtrCd,
        dlyPlcCd: dlyPlcCd,
        yyyymm: year + '' + month
      }
      this.$router.push({ name: 'leg', query: params }).catch(() => {})
    },
    async pdfDownload (fileName) {
      const result = await intergis.excelDownload(fileName)
      //blob 생성
      const blob = new Blob([result.data], { type: result.headers['content-type'] })

      if (window.navigator.msSaveOrOpenBlob) { //browser Check - IE
        window.navigator.msSaveOrOpenBlob(blob, fileName)
      } else { //browser Check - 그 외
        //<a>태그에 URL화 시킨 blob객체를 연결시킨 후 다운로드
        const link = document.createElement('a')
        const url = window.URL.createObjectURL(blob)
        link.href = url
        link.target = '_self'
        link.download = fileName
        link.click()

        //url 사용 후 메모리에서 제거
        window.URL.revokeObjectURL(url)
      }
    }
  }
}
</script>
